export class Step {
    name: string;
    step: number;

    constructor(params: { name: string, step: number }) {
        this.name = params.name;
        this.step = params.step;
    }
}